/*Genera Menu. entra como insumo el menú a pintar, tipo (1 o 2) es para el diseño, msjTipo2 es un texto que muestra en el menu */

//*react- recursos
  import Nav from "react-bootstrap/Nav";
  import Navbar from "react-bootstrap/Navbar";

//*clases
  import Container from "react-bootstrap/Container";
  import "./menu.css";

//*store's
  //import menuStore from "../../stores/menu.store";  

//*interfaces
  interface propsMenu {
    menu: any;
    tipo: any;
    msjTipo2: any
  }

//*componente
  export default function GeneraMenu(props: propsMenu) {  //*api store
    //console.log('GeneraMenu: menu', props.menu)
    //stores adicionales


    //*datos

    //*constantes y variables
    let menu = props.menu;

    //*usestate

    //*useEffect
    //*funciones
    
    const cambiaMenu = (opcMenu:any)=> {
      alert('cambio de ventana, cuando se utilice programar la entrada como se hizo para GeneraMenuSSC como variables store')
    } 
    
    //*vista
    return (
      <>
        <div>
          
                
          {/* Menú que se acomoda en cualquier parte*/}
          {props.tipo==1
            ?  <>
                <div id="navbar1">
                  {menu.map((item: any) => (
                    <>
                      {item.activo == true
                        ? (
                            /*  <a key={item.id} className="active">
                                {item.desc}
                              </a> */
                              <Nav.Link onClick={()=>cambiaMenu({item})} className="active">{item.desc}</Nav.Link>
                          ) 
                        : (
                          /* <a key={item.id}>{item.desc}</a> */
                          <Nav.Link onClick={()=>cambiaMenu({item})} >{item.desc}</Nav.Link>
                          )
                      }
                    </>
                  ))}
                </div>
               </>
            :  <></>
          }

          {/* Menu pegado arriba con una opción de mensaje a la izquierda, menu posterior de n elementos... */}
          {props.tipo==2
            ?  <>
                <div className="navbar">
                {menu.map((item: any) => (
                  <a key={item.id}>{item.desc}</a>
                ))}
                </div>
                <Navbar bg="light" expand="lg">
                  <Container fluid>
                    <Navbar.Brand href="#">{props.msjTipo2}</Navbar.Brand>
                    <Navbar.Toggle aria-controls="navbarScroll" />
                    <Navbar.Collapse id="navbarScroll">
                      <Nav
                        className="me-auto my-2 my-lg-0"
                        style={{ maxHeight: "100px" }}
                        navbarScroll
                      >
                        {menu.map((item: any) => (
                          <Nav.Link href="#action1">{item.desc} </Nav.Link>
                        ))}
                      </Nav>
                    </Navbar.Collapse>
                  </Container>
                </Navbar>
              </>
            : <></>
          }   
        </div>
      </>
    );
  }
